/** Rough icon match on a business entity's name, with a neutral fallback. */
export const entityIcon = (entityName) => {
    const name = (entityName || '').toLowerCase()
    if (name.indexOf('customer') !== -1) return 'uil-user'
    if (name.indexOf('product') !== -1) return 'uil-box'
    if (name.indexOf('order') !== -1) return 'uil-receipt'
    if (name.indexOf('invoice') !== -1) return 'uil-file-alt'
    if (name.indexOf('ship') !== -1) return 'uil-truck'
    if (name.indexOf('categor') !== -1) return 'uil-apps'
    if (name.indexOf('inventor') !== -1 || name.indexOf('stock') !== -1) return 'uil-cube'
    if (name.indexOf('currenc') !== -1) return 'uil-exchange'
    return 'uil-database'
}
